const CityTrainIcon = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="22"
      viewBox="0 0 18 22"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 0C2.68629 0 0 2.68629 0 6V9H18V6C18 2.68629 15.3137 0 12 0H6ZM11.2652 2H12.3287C12.4227 2 12.5096 2.04765 12.5566 2.125L14 4.5L12.5566 6.875C12.5096 6.95235 12.4227 7 12.3287 7H11.2652L12.4806 5H6.43094L5.82321 6H10.6604L10.0526 7H4L5.41299 4.675C5.4788 4.56671 5.4788 4.43329 5.41299 4.325L4 2H10.0526L10.6604 3H5.82322L6.43095 4H12.4806L11.2652 2Z"
        fill="#17171C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 11H0V16C0 17.1046 0.89543 18 2 18H16C17.1046 18 18 17.1046 18 16V11ZM5 14.5C5 15.3284 4.32843 16 3.5 16C2.67157 16 2 15.3284 2 14.5C2 13.6716 2.67157 13 3.5 13C4.32843 13 5 13.6716 5 14.5ZM16 14.5C16 15.3284 15.3284 16 14.5 16C13.6716 16 13 15.3284 13 14.5C13 13.6716 13.6716 13 14.5 13C15.3284 13 16 13.6716 16 14.5Z"
        fill="#17171C"
      />
      <path
        d="M3 18H5L3.24721 21.5056C3.0957 21.8086 2.786 22 2.44721 22C1.78231 22 1.34986 21.3003 1.64721 20.7056L3 18Z"
        fill="#17171C"
      />
      <path
        d="M13 18H15L16.3528 20.7056C16.6501 21.3003 16.2177 22 15.5528 22C15.214 22 14.9043 21.8086 14.7528 21.5056L13 18Z"
        fill="#17171C"
      />
      <rect x="3" y="19" width="12" height="2" fill="#17171C" />
    </svg>
  )
}

export default CityTrainIcon
